<template>
  <div id="categories" class="px-4 py-4">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'category-create' })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </div>
    <category-list />
  </div>
</template>
<script>
import CategoryList from "@/components/category_management/CategoryList.vue";
export default {
  components: {
    CategoryList
  }
};
</script>
